//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiBellOffOutline, mdiBellOutline } from '@mdi/js'

export default {
  setup() {
    const radioGroup = ref(1)

    return {
      radioGroup,
      icons: {
        mdiBellOffOutline,
        mdiBellOutline,
      },
    }
  },
}
